import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../services/contexts/user-context';
import Loading from './loading';

const RoleGuard = ({ children, allowedRoles = [], fallbackPath = '/default/profile' }) => {
  const { user, isLoading, error } = useUser();

  // 1. Still loading user data — show spinner
  if (isLoading && !error) {
    return <Loading />;
  }

  // 2. No user at all (auth error, 403, not logged in) — go to login
  //    This prevents the loop where two guards redirect to each other.
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // 3. User exists but has no role yet — send to onboarding
  if (!user.role) {
    return <Navigate to="/onboarding/choose-profile" replace />;
  }

  // 4. User has a role but it's not allowed here — redirect to their home
  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    return <Navigate to={fallbackPath} replace />;
  }

  // 5. All good — render the page
  return children;
};

export default RoleGuard;


